export default __webpack_public_path__ + "static/media/mark_logo.a05c95cc.webp";